export default __webpack_public_path__ + "static/media/wallet.37732f5c.svg";